import { BackendHttpService } from './backendHttpService';

export interface LanguageProficiencyOption {
  id: number;
  level: string;
}

export class LanguageProficiencyService extends BackendHttpService {
  constructor() {
    super('LanguageProficiency');
  }

  /**
   * Get all available language proficiency levels
   * @returns Promise with the proficiency level options
   */
  async getLanguageProficiencies(): Promise<LanguageProficiencyOption[]> {
    try {
      return await this.get<LanguageProficiencyOption[]>('');
    } catch (error) {
      console.error('Error fetching language proficiencies:', error);
      throw error;
    }
  }
} 